export default __webpack_public_path__ + "static/media/car.37e41f8f.png";